import React from "react"
import HeroSection from "../components/the-edge/HeroSection"
import Header from "../components/the-edge/Header"
import ParallaxSection from "../components/the-edge/ParallaxSection"
import ProjectSynopsis from "../components/the-edge/ProjectSynopsis"
import ProjectSpecifications from "../components/the-edge/ProjectSpecifications"
import Gallery from "../components/the-edge/Gallery"
import ProjectStatus from "../components/the-edge/ProjectStatus"
import ContactSection from "../components/the-edge/ContactSection"
import Location from "../components/the-edge/Location"
import Footer from "../components/common/Footer"
import Layout from "../components/common/Layout"
import { getSEOData } from "../utils/seo"
import "../css/the-edge.css"

const TheEdgePage = () => {
  const seoData = getSEOData("the-edge-gopalapuram-chennai")
  
  return (
    <Layout from="TheEdge" seoData={seoData}>
      <HeroSection />
      <Header />
      <ParallaxSection />
      <ProjectSynopsis />
      <ProjectSpecifications />
      <Gallery />
      <ProjectStatus />
      {/* <Location /> */}
      <ContactSection />
      {/* <Footer /> */}
    </Layout>
  )
}

export default TheEdgePage
